import React, {FC} from "react";

const Divider: FC = () => {
  return <>
    <div className="divider"/>
    <style jsx>{`
      .divider {
        margin: 3rem auto;
        height: 1px;
        background-color: #eee;
        width: 80%;
      }
    `}</style>
  </>
}

export default Divider;
